module.exports = __webpack_public_path__ + "static/media/blue-loader.c530c7df.svg";